import classNames from 'classnames'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import { ReactComponent as ModalXIcon } from '../../../../../../assets/images/common/icons/modal-X-icon.svg'
import classes from './WaitlistActionModal.module.scss'
import InfoPanel from '../InfoPanel'


const WaitlistActionModal = ({
  isOpen,
  onClose,
  student,
  title,
  subtitle,
  form,
  subHeaderSection = null,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onClose}
    contentLabel='Remove Student From Waitlist Modal'
    className={classNames(classes.waitlistActionModalContent)}
    autoFocus
  >
    <div id='WaitlistActionModal'>
      <div className='animated fadeIn'>
        <div className='d-flex justify-content-end text-align-right mb-4'>
          <ModalXIcon role='button' aria-label='close modal button' onClick={onClose} />
        </div>
        <div className={classes.subHeader}>
          <div>
            <h4 className='font-weight-bold mb-4'>{title}</h4>
            <p className={classes.subtitle}>{subtitle}</p>
          </div>
          <div>
            {subHeaderSection}
          </div>
          <div>
            <InfoPanel student={student} />
          </div>
        </div>
        {form}
      </div>
    </div>
  </Modal>
)

WaitlistActionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  student: PropTypes.any,
  form: PropTypes.node,
  subHeaderSection: PropTypes.node,
}

export default WaitlistActionModal
